import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EPDeviceSelectButton from 'editor-components/preview/EPDeviceSelectButton';
import { PREVIEW_DEVICES } from 'web-interactives-components/full-preview/constants/Preview';
import PreviewPageSelect from './PreviewPageSelect';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PreviewControls = ({
  handleDeviceChange,
  handleUrlChange,
  previewDevice,
  previewPageOptions,
  previewUrl,
  showPreviewPages,
  warningComponent: WarningComponent
}) => /*#__PURE__*/_jsxs(TFlex, {
  align: "center",
  direction: "row",
  justify: "between",
  wrap: "wrap",
  paddingBlockStart: "300",
  paddingInline: "600",
  children: [/*#__PURE__*/_jsx(Box, {
    children: showPreviewPages && /*#__PURE__*/_jsx(Flex, {
      flexDirection: "row",
      children: /*#__PURE__*/_jsxs(View, {
        marginInlineStart: "300",
        as: "div",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "fullPreview.previewOnPage"
        }), /*#__PURE__*/_jsx(PreviewPageSelect, {
          "data-test-id": "preview-page-select",
          onChange: handleUrlChange,
          options: previewPageOptions,
          value: previewUrl
        })]
      })
    })
  }), WarningComponent && /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(WarningComponent, {
      previewDevice: previewDevice
    })
  }), /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(EPDeviceSelectButton, {
      defaultValue: previewDevice,
      devices: [PREVIEW_DEVICES.DESKTOP, PREVIEW_DEVICES.MOBILE, PREVIEW_DEVICES.TABLET],
      onChange: handleDeviceChange
    })
  })]
});
export default PreviewControls;